module.exports = __webpack_public_path__ + "static/media/quieromibarrio2.e1cb2026.webp";